<template>
  <div v-if="commands && commands.length" class="dropdown" v-click-outside="closeDropdown">
    <button class="btn btn-lg dropdown-toggle w-100 d-flex justify-content-between align-items-center monospaced"
            type="button" 
            @click="toggleDropdown" 
            :aria-expanded="isOpen">
      <span v-if="selectedId !== null">{{ selectedCommand?.name }}</span>
      <span class="text-muted" v-if="selectedId === null"><i class="fa-solid fa-terminal"></i> Select a command</span>
    </button>
    <ul class="dropdown-menu w-100 mt-1" :class="{ 'show': isOpen }">
      <li v-for="command in commands"
          :key="command.id">
        <a class="dropdown-item"
           href="#"
           :class="{ 'active': command.id === selectedId }"
           @click.prevent="selectCommand(command)">
          <div class="d-flex align-items-center">
            <div><b>{{ command.name }}</b><br>
            <small>{{ command.description }}</small></div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CommandSelector',
  props: {
    commands: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedCommand() {
      return this.commands.find(command => command.id === this.selectedId)
    }
  },
  data() {
    return {
      selectedId: null,
      isOpen: false
    }
  },
  watch: {
    commands() {
      this.selectedId = null
    }
  },
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  methods: {
    selectCommand(command) {
      this.selectedId = command.id
      this.$emit('command-selected', command)
      this.isOpen = false
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  transform-origin: top;
  transition: all 0.1s ease-out;
  opacity: 0;
  transform: scaleY(0.9);
  display: block;
  pointer-events: none;
  padding: 0.25rem;
}

.dropdown-menu.show {
  opacity: 1;
  transform: scaleY(1);
  pointer-events: auto;
}

.dropdown-item {
  padding: 0.4rem 0.75rem;
  white-space: normal;
  border-radius: 0.25rem;
  line-height: 1.4;
}

.dropdown-item small {
  font-size: 0.8rem;
  opacity: 0.8;
  margin-top: -2px;
  display: block;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: var(--bs-primary);
  color: white;
}

.dropdown-toggle {
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: var(--bs-border-width) solid var(--bs-border-color);
  transition: outline 0.15s ease-in-out;
  padding: 0.5rem 0.75rem;
}

.dropdown-toggle[aria-expanded="true"] {
  border-color: var(--bs-primary);
  outline: 0;
  box-shadow: 0 0 0 .25rem rgba(13,110,253,.25);
}
</style>